<template>
  <div class="share" @click.self="$emit('closeShare')">
    <div class="popupholder">
      <img src="../assets/images/close.png" class="close_img cursor" @click="$emit('closeShare')">
      <div class="row m-0 text-center justify-content-center max100">
        <div class="col-12 p-0 max100">
          <div class="row m-0 text-center justify-content-center">
            <div class="col-12 p-0">
              <div class="row m-0 text_white blue_bg">
                <div class="col-12 p-3 font_light font22">
                  Share
                </div>
                <div class="col-12 pb-3">
                  <div class="row m-0 justify-content-center" >
                    <div class="col-6 col-sm-5 col-md-4 col-lg-3 col-xl-2 text-center">
                      <img src="../assets/images/ruggerbot_logo.png" class="img-fluid">
                    </div>
                    <div class="col-12 text-center my-2 font_light font20 p-0">
                      Rugby World Cup Score Predictor
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row m-0 text_blue text-center justify-content-center">
            <div class="col-12 col-sm-11 col-md-10 p-0 max100 scroll">
              <div class="row m-0 scroll">
                <div class="col-12 my-3 share_icons">
                  <facebook :url="url" scale="3"></facebook>
                  <twitter :url="url" title="Check out RuggerBot" scale="3"></twitter>
                  <linkedin :url="url" scale="3"></linkedin>
                  <!-- <telegram :url="url" scale="3"></telegram> -->
                  <whats-app :url="url" title="Ruggerbot" scale="3"></whats-app>
                  <!-- <pinterest :url="url" scale="3"></pinterest> -->
                  <!-- <reddit :url="url" scale="3" title="RuggerBot"></reddit> -->
                  <!-- <google :url="url" scale="3"></google> -->
                  <email :url="url" subject="RuggerBot" scale="3"></email>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  Facebook,
  Twitter,
  Linkedin,
  // Pinterest,
  // Reddit,
  // Telegram,
  WhatsApp,
  Email
  // Google
} from 'vue-socialmedia-share'
export default {
  name: 'Share',
  components: {
    Facebook,
    Twitter,
    Linkedin,
    // Pinterest,
    // Reddit,
    // Telegram,
    WhatsApp,
    Email
    // Google
  },
  data () {
    return {
      url: 'https://ruggerbot.com'
    }
  }
}
</script>
<style scoped>
.share {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background-color: rgba(0,0,0,0.9);
  padding: 5vh 10vw;
  z-index: 9999;
  line-height: 1.3;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
.share_icons > span {
  padding: 1em;
}
.popupholder {
  background-color: #ffffff;
  border-radius: 20px;
  max-height: 90vh;
  overflow-y: auto;
  padding-top: env(safe-area-inset-top) !important;
  /* overflow-y: hidden; */
}
.blue_bg {
  width: 100%;
  background-image: url(../assets/images/bg.jpg);
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 20px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.close_img {
  position: absolute;
  right: 7vw;
  top: 3vh;
  width: 20px;
  z-index: 11;
}
@media (min-width: 992px) {
  .close_img {
    right: 8.5vw;
    top: 3.5vh;
  }
}
</style>
